module.exports = {
    ...require('./header.table'),
    ...require('./footer.table'),
    ...require('./footerWithoutLimit.table')
}
